import { ProductTypes } from '../../../types';

export const useGetBinderNumber = ({
  isPrimePlus,
  policyNumber,
  product,
  quoteNumber,
}: Record<string, unknown>) => {
  return isPrimePlus ||
    product === ProductTypes.prime_tech_plus ||
    product === ProductTypes.p_one_plus ||
    product === ProductTypes.prime_one_tech_plus
    ? policyNumber
    : quoteNumber;
};
